export class PaginatedPatientAppointmentRequest {
    public pageIndex: number;
    public pageSize: number;
    public idStatus: number;
    public idMedicalSpecialty: number;

    public takePastAppointments: boolean;

    public dateStart: Date;
    public dateEnd: Date;
}